
module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/engine.io-client/index.js
// module id = 810
// module chunks = 0